import React from "react";
import {useState} from 'react';

import ExperienceDatas from "../contents/ExperienceDatas";

function Experiences (){
    console.log(ExperienceDatas[2].id)

  const [toggleTabs, setToggleTabs] = useState(ExperienceDatas[0].id);

  const toggleTab = (index) =>{
    setToggleTabs(index);
  }
  return (
    <section id='experience'>
      <div>
      <h2>Mes Experience</h2>
      <div className="tab">
      {ExperienceDatas.map((experience) => {
        return(
                <div className={toggleTabs === experience.id ? "tabActive" : ""}
                onClick={() => toggleTab(experience.id)}>
                  <p>{experience.Title}</p>
                </div>
                )}

  )}
      </div>

      <div className="content">
    {ExperienceDatas.map((experience) => {
        return(
                <div className={toggleTabs === experience.id ? "active" : ""}>
                  <h1>{experience.Title}</h1>
                  <h2>{experience.Subtitle}</h2>
                  <p>{experience.Content}</p>
                  <p className="date">{experience.Date}</p>
                </div>
                )}

  )}
      </div>
      </div>
    </section>
)};

export default Experiences;
